import { render, staticRenderFns } from "./InstaWidget.vue?vue&type=template&id=29e34f30&scoped=true"
import script from "./InstaWidget.vue?vue&type=script&lang=js"
export * from "./InstaWidget.vue?vue&type=script&lang=js"
import style0 from "./InstaWidget.vue?vue&type=style&index=0&id=29e34f30&prod&lang=scss&scoped=true"
import style1 from "./InstaWidget.vue?vue&type=style&index=1&id=29e34f30&prod&lang=scss"
import style2 from "./InstaWidget.vue?vue&type=style&index=2&id=29e34f30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e34f30",
  null
  
)

export default component.exports